const albumId = 26754993;
const albumDetails = {
	albumId,
	page: 1,
	filters: '{"has_permission":true,"approved":true}'
};
const stiffelStoriesAlbumDetails = {
	albumId: 33978969,
	page: 1,
	filters: '{"has_permission":true,"approved":true}'
};
const albumDetailsForPDP = {
	page: 1,
	filters: '{"has_permission":true,"approved":true, "filter_by_userhandle": {"not_equals": ["lampsplus"]}}',
	sort: '{"dynamic": true, "desc": true}'
};
const albumDetailsForinspireHomeDecor = {
	albumId: 50962736,
	page: 1,
	filters: '{"has_permission":true,"approved":true}'
};
const albumDetailsForLandingPage = {
	page: 1,
	filters:
		'{"has_permission":true,"approved":true, "content_type": ["image"], "filter_by_userhandle": {"not_equals": ["lampsplus"]}}'
};
const slidesToSlide = 6;
const slidesToSlideMobile = 2;
const showPerPageinstagramMobileItems = 10;
const shopByRoomItemsLimit = 24;
const slidesToShowSectionOnWidgetHome = 6;
const slidesToShowSectionOnWidgetHomePros = 6;

const shopByRoomIds = {
	livingRoom: 26754114,
	diningRoom: 26754125,
	kitchen: 26754128,
	bathroom: 26754137,
	bedroom: 26754138,
	office: 26754140,
	entryway: 26754141,
	outdoor: 26754144,
	smallSpace: 26754145
};

const UGCEventTypes = {
	home: {
		loadPage: 'Load-UGC-Homepage',
		pageAction: 'Click-UGC-Homepage',
		modalForwardArrowClick: 'Forward-Modal-Homepage',
		modalBackArrowClick: 'Back-Modal-Homepage',
		carouselForwardArrowClick: 'Forward-UGC',
		carouselBackArrowClick: 'Back-UGC',
		shopNowAction: 'Shop-Now-Homepage'
	},
	inspireHomeDecor: {
		loadPage: 'Load-UGC-Farah',
		pageAction: 'Click-UGC-Farah',
		modalForwardArrowClick: 'Forward-Modal-Farah',
		modalBackArrowClick: 'Back-Modal-Farah',
		shopNowButtonAction: 'Shop-Now-Farah',
		shopNowAction: ''
	},
	pdp: {
		loadPage: 'Load-UGC-PDP',
		pageAction: 'Click-UGC-PDP',
		modalForwardArrowClick: 'Forward-Modal-PDP',
		modalBackArrowClick: 'Back-Modal-PDP',
		carouselForwardArrowClick: 'Forward-UGC',
		carouselBackArrowClick: 'Back-UGC',
		ga4CarouselForwardArrowClick: 'pdp_customerphoto_forward',
		ga4CarouselBackArrowClick: 'pdp_customerphoto_back'
	},
	instagram: {
		loadPage: 'Load-UGC-UGC',
		pageAction: 'Click-UGC-UGC',
		modalForwardArrowClick: 'Forward-Modal-UGC',
		modalBackArrowClick: 'Back-Modal-UGC',
		shopNowAction: 'Shop-Now-UGC'
	},
	pros: {
		loadPage: 'Load-UGC-Pros',
		pageAction: 'Click-UGC-Pros',
		modalForwardArrowClick: 'Forward-Modal-Pros',
		modalBackArrowClick: 'Back-Modal-Pros',
		carouselForwardArrowClick: 'Forward-UGC',
		carouselBackArrowClick: 'Back-UGC',
		shopNowAction: 'Shop-Now-Pros'
	},
	inspiration: {
		loadPage: 'Load-UGC-Inspiration',
		pageAction: 'Click-UGC-Inspiration',
		modalForwardArrowClick: 'Forward-Modal-Inspiration',
		modalBackArrowClick: 'Back-Modal-Inspiration',
		shopNowAction: 'Shop-Now-Inspiration'
	}
};

const homeAndProsResponsiveConfig = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 1
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 1
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 }, // LampsPlus UI is same for Desktop and Tablet
		items: 1
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1
	}
};

const prosResponsiveConfig = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 1
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 1
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 }, // LampsPlus UI is same for Desktop and Tablet
		items: 1
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1
	}
};
const homeSlides = 1;
const prosSlides = 1;

const inspireMeConfig = {
	superLargeDesktop: {
		breakpoint: { max: 4000, min: 3000 },
		items: 4
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 4
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 }, // LampsPlus UI is same for Desktop and Tablet
		items: 4
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1
	}
};
const inspireMeSlides = 4;

const artificialPageViewEventTypes = {
	home: {
		popinPageName: 'Pixlee - Homepage'
	},
	instagram: {
		popinPageName: 'Pixlee - Instagram'
	},
	pros: {
		popinPageName: 'Pixlee - Pros'
	},
	inspiration: {
		popinPageName: 'Pixlee - Room & Inspiration'
	},
	inspireHomeDecor: {
		popinPageName: ''
	}
};

const widgetResponsiveConfig = {
	tablet: {
		breakpoint: { max: 1024, min: 464 }, // LampsPlus UI is same for Desktop and Tablet
		items: 4
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 2,
		partialVisibilityGutter: 40
	}
};

const modalConfig = {
	captions: {
		product: {
			showTurntoCaptions: true,
			showSocialCaptions: false
		},
		home: {
			showTurntoCaptions: true,
			showSocialCaptions: true
		},
		prosLanding: {
			showTurntoCaptions: true,
			showSocialCaptions: true
		},
		instagram: {
			showTurntoCaptions: true,
			showSocialCaptions: true
		},
		shopByRoom: {
			showTurntoCaptions: false,
			showSocialCaptions: false
		},
		manufacturer: {
			showTurntoCaptions: true,
			showSocialCaptions: true
		}
	},
	sliderSettings: {
		responsive: {
			superLargeDesktop: {
				breakpoint: { max: 4000, min: 3000 },
				items: 1
			},
			desktop: {
				breakpoint: { max: 3000, min: 1024 },
				items: 1
			},
			tablet: {
				breakpoint: { max: 1024, min: 464 },
				items: 1
			},
			mobile: {
				breakpoint: { max: 464, min: 0 },
				items: 1
			}
		},
		slidesToSlide: 1,
		arrows: false,
		swipeable: true,
		draggable: false,
		showDots: false,
		containerClass: 'PixleeMediaModal__slider',
		itemClass: 'PixleeMediaModal__slide',
		renderButtonGroupOutside: true,
		customTransition: 'none'
	}
};

export {
	homeAndProsResponsiveConfig,
	prosResponsiveConfig,
	homeSlides,
	prosSlides,
	albumDetails,
	UGCEventTypes,
	slidesToSlide,
	slidesToSlideMobile,
	showPerPageinstagramMobileItems,
	albumDetailsForPDP,
	shopByRoomIds,
	shopByRoomItemsLimit,
	stiffelStoriesAlbumDetails,
	artificialPageViewEventTypes,
	widgetResponsiveConfig,
	albumDetailsForinspireHomeDecor,
	modalConfig,
	slidesToShowSectionOnWidgetHome,
	slidesToShowSectionOnWidgetHomePros,
	inspireMeConfig,
	inspireMeSlides,
	albumDetailsForLandingPage
};
